import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTH_PREFIX_PATH, UNAUTHENTICATED_ENTRY, REDIRECT_URL_KEY } from "configs/AppConfig";

const ProtectedRoute = () => {
	const { token } = useSelector((state) => state.auth);
	const location = useLocation();

	if (!token) {
		return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${encodeURIComponent(location.pathname + location.search)}`} replace />;
	}

	return <Outlet />;
};

export default ProtectedRoute;
